module.exports = __webpack_public_path__ + "img/7.f10edde5.jpg";